RegProductInvoice.vue
<script>


export default {

  name: 'RegRequisitions',
  data() {
    return {
      loadingImage: require("@/assets/loading-waiting.gif"),
      availableFromSelectedProduct: 0,
      availableInventory: {},
      selectedDepartmentTitle: '',
      selectedProductName: '',
      selectedLocationName: '',
      locations: '',
      departments: '',
      products: '',
      requisition: {
        id: 0,
        code: '',
        requestedBy: 0,
        createdAt: "0000-01-01T01:01:01-06:00",
        deliveredTo: 0,
        deliveredBy: 0,
        deliveredAt: "0000-01-01T01:01:01-06:00",
        department: 0,
        location: 0,
      },
      items: [],
      item: {
        requisition: 0,
        product: 0,
        quantity: 0,
        delivered: 0,
        code: '',
        expires: "0000-01-01T01:01:01-06:00",
        batch: ''
      },
      loading: true,

    };
  },
  methods: {
    async getLocation() {
      try {
        let res = await this.$api.get("/auth/inventory/locations");
        if (res.status.toString() === "200") {
          this.locations = res.data
        }
      } catch (error) {
        console.log("can't get location data")
      }
    },
    async getProd() {
      try {
        let res = await this.$api.get("/auth/products");
        if (res.status.toString() === "200") {
          this.products = res.data
        }
      } catch (error) {
        console.log("can't get products data")
      }
    },
    async getDepartment() {
      try {
        let result = await this.$api.get("/auth/departments")
        if (result.status.toString() === "200") {
          this.departments = result.data
          for (let i = 0; i < this.departments.length; i++) {
            let temp = this.departments[i].id
            for (let j = i + 1; j < this.departments.length; j++) {
              if (temp === this.departments[j].id) {
                this.departments[i].child = this.departments[i].child + " | " + this.departments[j].child
                this.departments.splice(j, 1)
                j--
              }
            }
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se pudo obtener informacion requerida',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    addRow() {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].product === this.item.product) {
          this.$swal.fire({
            icon: 'error',
            title: '',
            text: 'Ya hay una entrada para este producto en la solicitud.',
            customClass: {
              popup: 'mySwal'
            }
          });
          return
        }
      }


      if (this.item.product < 1 || this.item.quantity < 1) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Verifique nuevamente los datos del producto a agregar.',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }

      if (this.item.quantity > this.availableFromSelectedProduct ) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No puede solicitar mas de lo que hay en existencia.',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }


      this.items.push({
        requisition: 0,
        product: this.item.product,
        quantity: this.item.quantity,
        delivered: 0,
        code: '',
        expires: "0000-01-01T01:01:01-06:00",
        batch: ''
      })


      this.selectedProductName = ''
      this.item = {
        requisition: 0,
        product: 0,
        amount: 0,
        delivered: 0,
        code: '',
        expires: "0000-01-01T01:01:01-06:00",
        batch: ''
      }
    },
    async regRequisition() {
      if (this.requisition.department < 1 ) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Seleccione un departmaneto valido',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }if (this.requisition.code.length < 3 ) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Codigo de requisición muy corto',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }if (this.requisition.location < 1) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ubicación invalida',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }if ( this.items.length < 1) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se ha agregado ningun producto',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }
      try {

        let formData = new FormData();

        let requisitionC = {...this.requisition}
        let requisitionJson = JSON.stringify(requisitionC);
        formData.append('requisition', requisitionJson)

        let itemsC = {...this.items}
        let itemsA = Object.values(itemsC)
        let itemsJson = JSON.stringify(itemsA)
        formData.append('requisitionItems', itemsJson)

        let res = await this.$api.post("/auth/requisitions", formData);
        if (res.status.toString() !== "200") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          }).then((result) => {
            if (result.isConfirmed) {
              this.requisition = {
                id: 0,
                code: '',
                requestedBy: 0,
                createdAt: "0000-01-01T01:01:01-06:00",
                deliveredTo: 0,
                deliveredBy: 0,
                deliveredAt: "0000-01-01T01:01:01-06:00",
                department: 0
              }
              this.items = []
              this.selectedDepartmentTitle = ''
              this.selectedProductName = ''
              this.selectedLocationName = ''

              this.item = {
                requisition: 0,
                product: 0,
                amount: 0,
                delivered: 0,
                code: '',
                expires: "0000-01-01T01:01:01-06:00",
                batch: ''
              }

              this.$router.push({name: 'ShowRequisition', params:{id:res.data}})
            }
          });
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'No se ha podido registrar la requisicion',
          customClass: {
            popup: 'mySwal'
          }
        });
        this.items = []
      }
    },
    getIDDepartment() {
      let selectedItem = this.departments.find(department => department.title === this.selectedDepartmentTitle);
      if (selectedItem !== undefined) {
        this.requisition.department = selectedItem.id
      }
    },
    getIDProduct() {
      let selectedItem = this.products.find(product => product.title.trim() === this.selectedProductName.trim());
      if (selectedItem !== undefined) {
        this.item.product = selectedItem.id
        this.availableFromSelectedProduct = this.getAvailableProductById(selectedItem.id).quantity
        if (this.availableFromSelectedProduct === undefined) {
          this.availableFromSelectedProduct = 0
        }
      }else{
        this.item.product = 0
        this.availableFromSelectedProduct = 0
      }
    },
    getAvailableProductById(id) {
      if (this.availableInventory.length > 0) {
      return this.availableInventory.find(prod => prod.productId === id) || {};
      } else {
        return {quantity : 0}
      }
    },
    getProductById(id) {
      return this.products.find(prod => prod.id === id) || {};
    },
    deleteProduct(index) {
      this.items.splice(index, 1)
    },
    getIDLocation() {
      let selectedItem = this.locations.find(loc => loc.name.trim() === this.selectedLocationName.trim());
      if (selectedItem !== undefined) {
        this.requisition.location = selectedItem.id
        this.getAvailableInventory(selectedItem.id)
      } else {
        this.requisition.location = 0
        this.loading = true
        this.availableInventory = {}
        this.items = []
        this.selectedProductName = ''
        this.item.product = 0
        this.item.quantity = 0
        this.availableFromSelectedProduct = 0
      }
    },
    async getAvailableInventory(id) {
      try {
        let res = await this.$api.get(`/auth/inventory/locations/${id}`, {})
        if (res.status.toString() === "200" ) {
          this.availableInventory = res.data
          this.loading = false
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    }
  },
  created() {
    this.getDepartment()
    this.getProd()
    this.getLocation()
  },
}

</script>

<template>

  <div id="section-0" class="container">


    <div class="form-reg-user">
      <h1>Registrar Requisición</h1>
      <form class="Form">
        <div class="grid-container">
          <!-- Column 1 -->
          <div>
            <!-- All your form elements for first column go here -->
            <label>Departamento</label>
            <input list="departments" v-model="selectedDepartmentTitle" @input="getIDDepartment" maxlength="250">
            <datalist id="departments">
              <option v-for="dep in departments" :key="dep.id" :value="dep.title"></option>
            </datalist>

            <label>Ubicación</label>
            <input list="locations" v-model="selectedLocationName" @input="getIDLocation" maxlength="250">
            <datalist id="locations">
              <option v-for="location in locations" :key="location.id" :value="location.name"></option>
            </datalist>
            <!-- more elements... -->
          </div>

          <!-- Column 2 -->
          <div>
            <!-- All your form elements for second column go here -->
            <label>Codigo</label>
            <input type="text" v-model="requisition.code" maxlength="6"
                   placeholder="######">


            <!-- more elements... -->
          </div>
        </div>

        <h2 v-if="requisition.location > 0">Detalle de requisición</h2>

        <p v-else>Seleccione una ubicación válida</p>

        <div v-if="loading" class="loading-spinner">
          <!-- Replace this with your loading spinner component or markup -->
          <img class="welcomeImage" :src="loadingImage" alt="loading image" height="15px" width="15px">
          <p>Cargando...</p>
        </div>
        <div v-else>
        <div class="grid-container">
          <!-- Column 1 -->
          <div>
            <!-- All your form elements for first column go here -->
            <label>Producto</label>
            <input list="products" v-model="selectedProductName" @input="getIDProduct" maxlength="250">
            <datalist id="products">
              <option v-for="product in products" :key="product.id" :value="product.title"></option>
            </datalist>

          </div>

          <!-- Column 2 -->
          <div>
            <!-- All your form elements for second column go here -->
            <label>Cantidad ({{availableFromSelectedProduct}} disponible)</label>
            <input type="number" step="1" placeholder="00" v-model="item.quantity">

            <!-- more elements... -->
          </div>
        </div>


        <button id="addRow" @click.prevent="addRow">Agregar</button>
        </div>
        <div class="container mt-4 table-container" v-if="items.length">
          <table id="myTable">
            <thead>
            <tr>
              <th>#</th>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Opciones</th>
            </tr>

            </thead>
            <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ getProductById(item.product).title }}</td>
              <td>{{ item.quantity }}</td>
              <td class="td_align_center">
                <button class="tableBtn" type="submit" @click.prevent="deleteProduct(index)">Eliminar</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-else>
          <p class="bordered-p">No se han registrado productos aun</p>
        </div>


        <button type="submit" @click.prevent="regRequisition">Registrar</button>
      </form>
    </div>

  </div>
</template>


<style scoped>
</style>